<template>
  <div class="my_module_animation">
    <ul class="animation_list">
      <li
        class="animation_item"
        v-for="(item, index) in [4,0,5,1,6,2,7,3]"
        :key="index"
        :data-active="item === activeIndex"
        @click="change_item(item)"
      >
        <div class="animation_img">
          <div
            class="type_img"
            :class="`type_img_${item}`"
          ></div>
          <span class="active-icon el-icon-check"></span>
        </div>
        <div class="animation_title">{{ moduleAnimationList[item].typeTitle }}</div>
      </li>
    </ul>
    <div class="animation_setting">
      <my_radio
        :title="$t('components_my_animation_my_banner_animation_2288')"
        hiddenIsShow="false"
        titleWidth="65"
        :selectValue.sync="infor.banner_set.radio_val"
        :option="$store.state.options.banner_set_option"
      ></my_radio>
      <template v-if="infor.banner_set.radio_val === 'custom'">
        <my_slider
          titleWidth="65"
          :title="$t('widgets_basic_article_list_edit_389')"
          :value.sync="infor.banner_set.custom.delay"
          symbol="s"
          :min="1"
          :max="10"
          @handle_stop_change="banner_set_change"
        ></my_slider>
        <my_slider
          class="Switching_speed"
          titleWidth="65"
          :title="$t('widgets_basic_article_list_edit_390')"
          :value.sync="infor.banner_set.custom.speed"
          symbol="s"
          :min="1"
          :max="5"
          @handle_stop_change="banner_set_change"
        ></my_slider>
      </template>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import moduleAnimationList from './banner_animation_list.js'

export default {
  name: 'my_banner_animation',
  props: {
    defalutActive: {
      type: Number,
      default: 0
    },
    defaultFormData: {
      type: Object,
      default: () => {
      }
    }
  },
  watch: {
    moduleAnimationList: {
      handler(val) {
        this.$emit('change', {
          typeTitle: val[this.activeIndex].typeTitle,
          id: val[this.activeIndex].id,
          formData: val[this.activeIndex].formData
        })
      },
      deep: true
    },
    activeIndex(val) {
      this.$emit('change', {
        typeTitle: this.moduleAnimationList[val].typeTitle,
        id: this.moduleAnimationList[val].id,
        formData: this.moduleAnimationList[val].formData
      })
    }
  },
  data() {
    return {
      moduleAnimationList: JSON.parse(JSON.stringify(moduleAnimationList)),
      activeIndex: this.defalutActive
    }
  },
  computed: {
    infor() {
      return this.$store.state.app.module_Data.data.infor;
    },
  },
  mounted() {
    if (this.defaultFormData) {
      this.moduleAnimationList[this.activeIndex].formData = this.defaultFormData
    }
    // this.$emit('change', { typeTitle: this.moduleAnimationList[this.activeIndex].typeTitle, id: this.moduleAnimationList[this.activeIndex].id, formData: this.moduleAnimationList[this.activeIndex].formData })
  },
  methods: {
    change_item(index) {
      this.activeIndex = index
    },
    change_slider(val) {
      console.log(val)
    },
    banner_set_change() {
      //要重新渲染轮播图
      this.templet.full_banner_render();
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";

.my_module_animation {
  .animation_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 22px;

    .animation_item {
      margin: 7px 0;

      .animation_img {
        position: relative;
        margin: 0 0px;
        width: 170px;
        height: 96px;
        line-height: 76px;
        text-align: center;
        //border: 1px solid #e1e1e1;
        cursor: pointer;
        text-align: center;

        .active-icon {
          display: none;
          width: 18px;
          height: 16px;
          color: #fff;
          position: absolute;
          bottom: 10px;
          right: 8px;
          background-color: #5874d8;
          line-height: 22px;
          font-size: 12px;
          padding: 0 3px;
          border-top-left-radius: 100%;
        }

        .type_img {
          display: inline-block;
          line-height: 50px;
          width: 153px;
          height: 86px;
          text-align: center;
          vertical-align: middle;
          background-size: cover;
          border: 1px solid #e1e1e1;
          border-radius: 10px;


          &.type_img_0 {
            background-image: url("/static/image/animation/1.png");
          }

          &.type_img_1 {
            background-image: url("/static/image/animation/2.png");
          }

          &.type_img_2 {
            background-image: url("/static/image/animation/3.png");
          }

          &.type_img_3 {
            background-image: url("/static/image/animation/4.png");
          }

          &.type_img_4 {
            background-image: url("/static/image/animation/5.png");
          }

          &.type_img_5 {
            background-image: url("/static/image/animation/6.png");
          }

          &.type_img_6 {
            background-image: url("/static/image/animation/7.png");
          }

          &.type_img_7 {
            background-image: url("/static/image/animation/8.png");
          }

          &:hover {
            border-color: $theme-primary;
          }
        }
      }

      .animation_title {
        text-align: center;
        cursor: pointer;
      }

      &[data-active] {
        .type_img {
          border-color: $theme-primary;
        }

        .animation_img {
          border-color: $theme-primary;

          .active-icon {
            display: block;
          }
        }
      }
    }
  }

  .animation_setting {
    border-top: 1px dashed #def0ff;
    padding-top: 20px;

    .setting_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;

      .setting_title {
        display: inline-block;
        width: 50px;
        text-align: right;
        vertical-align: middle;
        font-size: 13px;
        line-height: 1;
      }

      .setting_content {
        flex: 1;
        margin-left: 8px;
      }

      .m-l-6 {
        margin-left: 5px;
      }

      &.setting_radio {
        align-items: flex-start;
        min-height: 40px;

        .setting_content {
          display: inline-block;

          /deep/ .el-radio {
            margin: 0 15px 15px 0;
          }
        }

        &.setting_trigger {
          align-items: center;
          margin-bottom: 15px;

          .setting_content {
            /deep/ .el-radio {
              margin: 0 15px 0 0;
            }
          }
        }
      }

      &.setting_slider {
        .setting_title {
          margin-bottom: 8px;
        }

        .setting_content {
          flex: 0 0 220px;
          display: flex;
          flex-direction: row;
          justify-content: center;

          /deep/ .my_slider_layer {
            .module {
              margin-left: 0;
            }
          }
        }
      }
    }
  }
}
</style>

<style>
.my_module_animation .m-l-6 .setting_title {
  margin-left: 6px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/my_animation/my_banner_animation.vue